import { useEffect, useReducer } from 'react';
import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from 'hooks/useOrgId.js';

const simpleReducer = (state, updates) => {
  return { ...state, ...updates };
};

/**
 * Live settings documents of the current org, or of `orgIdOverride` where the
 * page has no current org (the superadmin area).
 */
export const useOrgSettings = (scopes = [], orgIdOverride) => {
  const { firestore } = useFirebase();
  const [orgSettings, dispatchOrgSettings] = useReducer(simpleReducer, { loading: true });

  const currentOrgId = useOrgId();
  const orgId = orgIdOverride || currentOrgId;

  useEffect(() => {
    if (!orgId) return;
    if (!firestore) return;

    const unsubscribeFunctions = scopes.map((scope) =>
      firestore
        .collection('organizations')
        .doc(orgId)
        .collection('settings')
        .doc(scope)
        .onSnapshot(
          (documentSnapshot) => {
            if (!documentSnapshot.exists) {
              dispatchOrgSettings({ [scope]: undefined, loading: false });
              return;
            }
            const newSettings = documentSnapshot.data();
            dispatchOrgSettings({ [scope]: newSettings, loading: false });
          },
          (firestoreError) => {
            console.error('Could not get settings from firestore', firestoreError);
            dispatchOrgSettings({ [scope]: undefined, loading: false });
          },
        ),
    );
    // return cleanup function for effect
    return () => {
      unsubscribeFunctions.forEach((unsubscribe) => {
        if (typeof unsubscribe === 'function') unsubscribe();
      });
    };
  }, [orgId, firestore]);

  return orgSettings;
};
